import { BiDownArrow } from 'react-icons/bi';
import './Processes.sass';
import { FlagBrasil, FlagChile } from '../../Icons/Flags';

const mockData = [
  {
    vacante: 'Gerente De Logistica',
    company: 'Bix S.a.',
    country: 'BR',
    area: 'Almacén, logistica y transporte',
    status: 'Postulación enviada',
    description: 'Fringilla at ullamcorper sed proin. Malesuada placerat tempor sit dui cras lorem accumsan. At praesent odio diam risus eget in faucibus tincidunt. Bibendum elit imperdiet rutrum condimentum amet sit enim vel. Consectetur neque auctor pulvinar tellus adipiscing ante. Odio eros sed cursus lectus in. Cursus sodales egestas tortor nisl quam et at quam vel. Neque sodales aliquam eget nisi ullamcorper amet proin enim. Ultricies sed facilisi facilisi fames. At ac nec eu lectus iaculis integer nibh ullamcorper dolor.',
  },
  {
    vacante: 'Jefe De Logística Y Abastecimiento',
    company: 'Minera BMR SPA',
    country: 'CL',
    area: 'Proyectos',
    status: 'Postulación enviada',
    description: 'Fringilla at ullamcorper sed proin. Malesuada placerat tempor sit dui cras lorem accumsan. At praesent odio diam risus eget in faucibus tincidunt. Bibendum elit imperdiet rutrum condimentum amet sit enim vel. Consectetur neque auctor pulvinar tellus adipiscing ante. Odio eros sed cursus lectus in. Cursus sodales egestas tortor nisl quam et at quam vel. Neque sodales aliquam eget nisi ullamcorper amet proin enim. Ultricies sed facilisi facilisi fames. At ac nec eu lectus iaculis integer nibh ullamcorper dolor.',
  },
  {
    vacante: 'Analista Contable (Cuentas Por Pagar) - Bogotá',
    company: '032 Comunicaciones',
    country: 'BR',
    area: 'Investigacion y desarrollo (R&D)',
    status: 'Postulación enviada',
    description: 'Fringilla at ullamcorper sed proin. Malesuada placerat tempor sit dui cras lorem accumsan. At praesent odio diam risus eget in faucibus tincidunt. Bibendum elit imperdiet rutrum condimentum amet sit enim vel. Consectetur neque auctor pulvinar tellus adipiscing ante. Odio eros sed cursus lectus in. Cursus sodales egestas tortor nisl quam et at quam vel. Neque sodales aliquam eget nisi ullamcorper amet proin enim. Ultricies sed facilisi facilisi fames. At ac nec eu lectus iaculis integer nibh ullamcorper dolor.',
  },
];

const Processes = () => {
  return (
    <div className="processesStyle">
      <div className="row mb-5 align-items-center">
        <div className="col-1">
          <span className="title-icon p-2 m-auto"></span>
        </div>
        <div className="col-8">
          <p className="title">Meus Processos</p>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Vacante</th>
              <th scope="col">Empresa</th>
              <th scope="col">País</th>
              <th scope="col">Área</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {mockData.map((item, key) => {
              return (
                <>
                  <tr key={key} data-bs-toggle="collapse" data-bs-target={`#process` + key} aria-expanded="false" aria-controls={`process` + key}>
                    <td>{item.vacante}</td>
                    <td>{item.company}</td>
                    <td>{item.country === 'BR' ? <FlagBrasil width='25' height='25' /> : item.country === 'CL' ? <FlagChile width='25' height='25' /> : ''}</td>
                    <td>{item.area}</td>
                    <td>
                      <div className={item.status === `Postulación enviada` ? `status underAnalysis` : item.status === `Aprovado` ? `status approved` : item.status === `Reprovado` ? `status disapproved` : `status`}>{item.status}</div>
                    </td>
                    <td className="arrow">
                      <BiDownArrow size={25} />
                    </td>
                  </tr>
                  <tr className="collapse" id={`process` + key}>
                    <td colSpan={5}>
                      <div className="description p-3">{item.description}</div>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Processes;
